function initializeRepossessedAuto() {
  var ne = document.getElementsByClassName('control-next-btn');
  var pre = document.getElementsByClassName('control-prev-btn');
  for (var i = 0; i < ne.length; i++) {
    ne[i].addEventListener('click', (event) => {
      event.preventDefault();
      let currentId = event.target.id;
      let sliderContainer = event.target.parentElement;
      let content = sliderContainer.parentElement;
      sliderContainer.scrollLeft += 270;
      content.scrollLeft += 270;
    });
  }
  // #slider-container.slider.c
  for (var i = 0; i < pre.length; i++) {
    pre[i].addEventListener('click', (event) => {
      event.preventDefault();
      let currentId = event.target.id;
      let sliderContainer = event.target.parentElement;
      let content = sliderContainer.parentElement;
      sliderContainer.scrollLeft -= 270;
      content.scrollLeft -= 270;
    });
  }

}


document.addEventListener('DOMContentLoaded', (event) => {
  initializeRepossessedAuto()
})
